export const convertPhoneToDb = (phoneValue: string, phoneCode: string): string => {
    return (phoneCode + phoneValue).padStart(phoneValue.length + 3, '0');
};
